import { useState } from "react";
import { Link } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import { IconButton, Stack } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import NavDrawer from "./NavDrawer";
// import TransLang from "./TransLang"
// import { useTranslation } from "react-i18next";
import logo from './../../assets/Logo/logo.png'
import { Facebook, Instagram, Twitter } from '@mui/icons-material'
import TransLang from "./TransLang"

import './Nav.css'
function NavBar() {
    // const { t } = useTranslation()
    const [drawer, setDrawer] = useState(false);
    return (
        <>
            <AppBar position="static" elevation={0}
                style={{
                    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                    // backgroundColor: "rgb(104 12 23 / 90%)",
                    backgroundColor: "#13103f",
                    padding: "10px"
                }}>
                <Container>
                    <Toolbar disableGutters>

                        <Link
                            to="/"
                            style={{
                                color: "#FFF",
                                textDecoration: "none",
                                marginLeft: "10%",
                            }}
                        >
                            <img src={logo} height={50} alt="logo" className="nav-logo" ></img>
                        </Link>
                        {/* <Link
                            to="/"
                            style={{
                                color: "#FFF",
                                textDecoration: "none",
                                marginLeft: "10%",

                            }}

                        >
                            <Typography sx={{ display: { md: "none", xs: "flex" }, fontSize: '1.25rem' }}>{t('title')}</Typography>
                        </Link> */}
                        {/* <Box
                            sx={{
                                flexGrow: 1,
                                marginInlineStart: 8,
                                gap: 5,
                                display: { md: "flex", xs: "none" },
                                alignItems: "center",
                                justifyContent: 'flex-start'
                            }}>
                            <Link
                                to="/"
                                style={{
                                    color: "#FFF",
                                    textDecoration: "none",
                                    fontSize: 18,
                                    fontWeight: "bold",
                                }}>
                                {t('linksPages.home')}
                            </Link>
                            <Link
                                to="/service"
                                style={{
                                    color: "#FFF",
                                    textDecoration: "none",
                                    fontSize: 18,
                                    fontWeight: "bold",
                                }}>
                                {t('linksPages.PhotoGallery')}
                            </Link>
                            <Link
                                to="/about"
                                style={{
                                    color: "#FFF",
                                    textDecoration: "none",
                                    fontSize: 18,
                                    fontWeight: "bold",
                                }}>
                                {t('linksPages.aboutUs')}
                            </Link>
                            <Link
                                to="/contact"
                                style={{
                                    color: "#FFF",
                                    textDecoration: "none",
                                    fontSize: 18,
                                    fontWeight: "bold",
                                }}>
                                {t('linksPages.contact')}
                            </Link>
                        </Box> */}

                        <Box sx={{ justifyContent: 'end', display: 'flex', gap: { md: '65px', xs: 1 }, width: '100%', alignItems: 'center' }} >

                            <Box mt={'15px'} >
                                <Stack direction="row" sx={{ gap: { md: '50px', xs: 1 } }} justifyContent={"space-evenly"} alignItems={'center'} margin={"0 5%"}  >
                                    <Box >
                                        <Link
                                            to="https://www.facebook.com/profile.php?id=61550191435395"
                                            style={{
                                                color: "inherit",
                                                textDecoration: "none",
                                                fontSize: 15,
                                                fontWeight: "bold",
                                            }}>
                                            <Facebook sx={{ fontSize: { md: '3rem', xs: '3rem' }, color: '#fff' }} />
                                        </Link>
                                    </Box>
                                    <Box >
                                        <Link
                                            to="https://www.snapchat.com/add/theprofessorgen?share_id=4_EuHWoZ80k&locale=en-GB"
                                            style={{
                                                color: "inherit",
                                                textDecoration: "none",
                                                fontSize: 15,
                                                fontWeight: "bold",
                                            }}>
                                            <svg fill="#fff" viewBox="0 0 256 256" id="Flat" xmlns="http://www.w3.org/2000/svg" stroke="#fff" style={{ width: '30px' }} ><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M249.36426,186.78713a11.9214,11.9214,0,0,0-6.76856-8.958c-1.3872-.66748-25.52636-12.74414-38.49853-48.14355l16.35986-6.544a12,12,0,0,0-8.91406-22.2832L198.04,106.25979A162.8006,162.8006,0,0,1,196,80,68,68,0,0,0,60,80a162.78977,162.78977,0,0,1-2.04,26.25928l-13.50342-5.40088a11.99983,11.99983,0,0,0-8.91308,22.2832l16.35986,6.54346c-12.93359,35.293-36.96582,47.40381-38.48535,48.13721a12.00069,12.00069,0,0,0-3.10742,19.61035c8.21582,7.71094,19.24609,8.44726,28.97754,9.09765,5.09472.33985,10.86816.72559,13.584,2.22071,2.59131,1.42578,5.94434,6.02246,8.90234,10.07715,5.51661,7.5625,12.38184,16.97363,23.479,19.81347a26.73407,26.73407,0,0,0,6.65771.8291c8.19825,0,15.83789-3.56054,22.74854-6.78125C119.60742,230.38381,124.72266,228,128,228s8.39355,2.38379,13.34082,4.68945c8.74951,4.07715,18.665,8.70508,29.40723,5.95118,11.0957-2.83887,17.96093-12.25,23.47754-19.81153,2.958-4.05566,6.311-8.65234,8.90234-10.07812,2.71582-1.49512,8.49023-1.88086,13.584-2.22071,9.73194-.65039,20.76172-1.38671,28.978-9.09765A11.99019,11.99019,0,0,0,249.36426,186.78713Zm-57.81006.93848c-7.26367,3.998-12.28662,10.88379-16.71826,16.959-3.25147,4.457-7.29785,10.00488-10.03711,10.70508-2.42725.61816-8.72363-2.31152-13.32031-4.4541C144.502,207.68459,136.59473,204,128,204s-16.50195,3.68457-23.478,6.93555c-4.59619,2.14355-10.88623,5.07422-13.31982,4.45508-2.74024-.70118-6.78662-6.249-10.03809-10.70606-4.43164-6.07519-9.4541-12.96-16.71728-16.959-5.75537-3.168-12.252-4.21485-18.43067-4.76172C63.22314,165.9717,84,134.22756,84,80a44,44,0,0,1,88,0c0,54.22754,20.77686,85.97168,37.98438,102.96387C203.80566,183.51076,197.30957,184.55764,191.5542,187.72561Z"></path> </g></svg>
                                        </Link>
                                    </Box>
                                    <Box >
                                        <Link
                                            to="https://www.instagram.com/theprofessorgeneralcontracting/"
                                            style={{
                                                color: "inherit",
                                                textDecoration: "none",
                                                fontSize: 15,
                                                fontWeight: "bold",
                                            }}
                                        >
                                            <Instagram sx={{ fontSize: { md: '3rem', xs: '3rem' }, color: '#fff' }} />
                                        </Link>
                                    </Box>
                                    <Box >
                                        <Link
                                            to="https://twitter.com/TheProfess37451"
                                            style={{
                                                color: "inherit",
                                                textDecoration: "none",
                                                fontSize: 15,
                                                fontWeight: "bold",
                                            }}
                                        >
                                            <Twitter sx={{ fontSize: { md: '3rem', xs: '3rem' }, color: '#fff' }} />
                                        </Link>
                                    </Box>
                                </Stack>
                            </Box>
                            <TransLang />
                            <Box
                                sx={{
                                    flexGrow: 0,

                                    // display: { md: "none", xs: "flex" },
                                    display: 'flex',
                                    justifyContent: "end",
                                }}>
                                <IconButton onClick={() => setDrawer(true)}>
                                    <MenuIcon sx={{ fontSize: '3rem', color: '#FFF', marginTop: '30%' }} />
                                </IconButton>
                            </Box>
                        </Box>
                        {/* <TransLang /> */}
                    </Toolbar>
                </Container>
            </AppBar>
            <NavDrawer drawer={drawer} setDrawer={setDrawer} />
        </>
    );
}
export default NavBar;
